
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.825 4.342L14 6.692c.158.325.583.633.942.7l2.125.35c1.358.225 1.675 1.208.7 2.191l-1.659 1.659c-.275.275-.433.816-.341 1.208l.475 2.05c.375 1.617-.492 2.25-1.917 1.4l-1.992-1.183c-.358-.217-.958-.217-1.316 0L9.025 16.25c-1.425.842-2.292.217-1.917-1.4l.475-2.05c.075-.4-.083-.942-.358-1.217L5.567 9.925c-.975-.975-.659-1.958.7-2.192l2.125-.35c.358-.058.783-.375.941-.7l1.175-2.35c.642-1.266 1.675-1.266 2.317.009zM6.667 4.792h-5a.63.63 0 01-.625-.625.63.63 0 01.625-.625h5a.63.63 0 01.625.625.63.63 0 01-.625.625zM4.167 16.458h-2.5a.63.63 0 01-.625-.625.63.63 0 01.625-.625h2.5a.63.63 0 01.625.625.63.63 0 01-.625.625zM2.5 10.625h-.833A.63.63 0 011.042 10a.63.63 0 01.625-.625H2.5a.63.63 0 01.625.625.63.63 0 01-.625.625z","fill":"#FFBF00"}})])
          )
        }
      }
    